export default "__VITE_ASSET__CfiFXRR7__"